/* eslint-disable */
const USER_KEY = 'user';
const ORDER_STATE_KEY = 'order_state';
const Platform_TYPE = 'MARKETPLACE_TYPE';
const PAGE_AFTER_AUTHENTICATION = 'AFTER_AUTH';
const Product_ATTRIBUTES_KEY = 'PRODUCT_ATTRIBUTES';
const SUPPORTED_COUNTRY_KEY = 'SUPPORTED_COUNTRY';

class SessionHelper {
	getObjectFromString(str) {
		if (str) return JSON.parse(str);
		return null;
	}

	getStringFromObject(obj) {
		return JSON.stringify(obj);
	}

	saveSessionUser(user) {
		const userInfoToSave = {
			avatar: user.avatar || null,
			name: user.name || null
		};
		// console.log('saving user',user);
		sessionStorage.setItem(USER_KEY, this.getStringFromObject(userInfoToSave));
	}

	removeUser() {
		sessionStorage.removeItem(USER_KEY);
		sessionStorage.removeItem(PAGE_AFTER_AUTHENTICATION);
		// sessionStorage.clear();
	}

	isUserLoggedIn() {
		if (this.getSessionUser()) return true;
		return false;
	}

	setSupportedCountry(country) {
		sessionStorage.setItem(SUPPORTED_COUNTRY_KEY, country);
	}

	getSupportedCountry() {
		return sessionStorage.getItem(SUPPORTED_COUNTRY_KEY);
	}

	removeSupportedCountry() {
		sessionStorage.removeItem(SUPPORTED_COUNTRY_KEY);
	}

	getSessionUser() {
		const userStr = sessionStorage.getItem(USER_KEY);
		return this.getObjectFromString(userStr);
	}

	setProductAttributes(obj) {
		sessionStorage.setItem(Product_ATTRIBUTES_KEY, this.getStringFromObject(obj));
	}

	getProductAttributes() {
		const obj = sessionStorage.getItem(Product_ATTRIBUTES_KEY);
		return this.getObjectFromString(obj);
	}

	getOrderState() {
		const stateStr = sessionStorage.getItem(ORDER_STATE_KEY);
		return this.getObjectFromString(stateStr);
	}

	saveOrderState(state) {
		sessionStorage.setItem(ORDER_STATE_KEY, this.getStringFromObject(state));
	}

	set(key, value) {
		sessionStorage.setItem(key, value);
	}

	get(key) {
		return sessionStorage.getItem(key);
	}

	setObject(key, object) {
		sessionStorage.setItem(key, this.getStringFromObject(object));
	}

	getObject(key) {
		const obj = sessionStorage.getItem(key);
		return this.getObjectFromString(obj);
	}

	removeObject(key) {
		sessionStorage.removeItem(key);
	}

	setMarketplaceType(obj) {
		sessionStorage.setItem(Platform_TYPE, this.getStringFromObject(obj));
	}

	getMarketplaceType(obj) {
		const mtype = sessionStorage.getItem(Platform_TYPE);
		return this.getObjectFromString(mtype);
	}

	setLocalStorageObject(key, object) {
		localStorage.setItem(key, JSON.stringify(object));
	}

	getLocalStorageObject(key) {
		return JSON.parse(localStorage.getItem(key));
	}

	removeLocalStorageItem(key) {
		localStorage.removeItem(key);
	}
}

export default new SessionHelper();
